import { useEffect, useState } from "react"
import { Modal } from "flowbite-react"
import { useToastContext } from "../../../../common/components/ui/toast/toast.context"
import Loading from "../../../../common/components/ui/loading/Loading"
import { linkCollector } from "../../../../common/services/repossession.api"
import FormCollector from "../forms/FormCollector"

type Props = {
  data: {
    plate: string;
    repossessionId: string;
  }
  onClose: () => void
}

export default function ModalCollector(props: Props) {
  const [vehicle, setVehicle] = useState<string | null>(null)
  const { showToast } = useToastContext()
  const [formRequestErrors] = useState([])

  const notifySuccess = (text: string) => showToast({ text, type: 'success' })
  const notifyError = (text: string) => showToast({ text, type: 'error' })

  const handleCloseModal = () => { props.onClose() }

  useEffect(() => { props.data.plate !== vehicle && setVehicle(props.data.plate) }, [props.data.plate, vehicle])

  async function submitLinkCollector(formData: { cpf: string; pixKeyType: string; pixKey: string; }) {
    try {
      if (!props.data.repossessionId) {
        notifyError("Não foi possível identificar o recolhimento para vincular o recolhedor.");
        return { ok: false };
      }

      const response = await linkCollector(vehicle as string, {
        ...formData,
        repossessionId: props.data.repossessionId,
      });

      const { ok } = response;

      if (ok) {
        setVehicle(null);
        notifySuccess(`Recolhedor vinculado ao veículo com sucesso!`);
        handleCloseModal();
        return { ok };
      }

      if (!ok) {
        notifyError(response.message || "Erro ao tentar vincular recolhedor ao veículo");
      }

      return { ok };
    } catch (err) {
      notifyError("Erro ao tentar vincular recolhedor ao veículo");
      return {
        ok: false,
        data: formData,
        errors: [{ message: (err instanceof Error ? err.message : 'Unknown error'), path: [] }],
      };
    }
  }

  return (
    <Modal
      size={'5xl'}
      className='relative'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black'>
        <div className="flex items-center justify-start gap-3 text-black">
          <span>
            {`Vincular Recolhedor - ${vehicle}`}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body className='w-full relative border-gray flex flex-col text-black' style={{ minHeight: 'calc(50vh - 300px)', height: 'calc(100vh - 300px)' }}>
        {vehicle ? (
          <FormCollector data={vehicle} onSubmit={submitLinkCollector} formRequestErrors={formRequestErrors} />
        ) : <Loading />}
      </Modal.Body>
    </Modal>
  );
}
